@if (loadingService.loading$ | async) {
  <div class="loading-overlay">
    <tds-spinner size="lg" variant="standard"></tds-spinner>
  </div>
}
<router-outlet></router-outlet>